import './App.css';
import { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

/* ════ RANDOM NICK GENERATOR ════ */
const PREFIXES = ['kral','queen','dark','cool','real','mini','mega','lord','lady','mad','zen','neo','lil','big','dj'];
const NAMES = ['ayse','mehmet','ece','berk','deniz','can','su','ali','selin','mert','elif','yusuf','defne','kerem','zeynep','emre','nil','arda','ceren','burak'];
const SUFFIXES = ['xx','99','34','06','_','ist','tr','00','61','48','35','16','01','42','53'];

function randomTroll() {
  const prefix = Math.random() < 0.5 ? PREFIXES[Math.floor(Math.random() * PREFIXES.length)] : '';
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const suffix = SUFFIXES[Math.floor(Math.random() * SUFFIXES.length)];
  return { handle: `@${prefix}${name}${suffix}` };
}

/* ════ ÖNEMLİ KİTAPLAR ════ */
const BOOKS = [
  { title: 'Tartışma Sanatı', author: 'Arthur Schopenhauer', review: '' },
  { title: 'Kendime Düşünceler', author: 'Marcus Aurelius', review: '' },
  { title: 'Budala', author: 'Fyodor Dostoyevski', review: '' },
  { title: 'The Art of War', author: 'Sun Tzu', review: '' },
  { title: 'Böyle Buyurdu Zerdüşt', author: 'Friedrich Nietzsche', review: '' },
  { title: 'The Courage to Be Disliked', author: 'Ichiro Kishimi', review: '' },
  { title: '48 Laws of Power', author: 'Robert Greene', review: '' },
  { title: 'Prens', author: 'Niccolò Machiavelli', review: '' },
];

/* ════ ÖNEMLİ SÖZLER ════ */
const QUOTES = [
  { text: 'Asla bir domuzla güreşme. İkiniz de çamur içinde kalırsınız ama o bundan keyif alır.', author: 'George Bernard Shaw' },
];

/* ════ YAĞMUR SÖZLERİ — gerçek, kaynaklı ════ */
const RAIN_QUOTES = [
  { text: 'canavarlarla savaşan, canavar olmamaya dikkat etsin', author: 'Nietzsche' },
  { text: 'delilik bireylerde istisnadır, kitlelerde kuraldır', author: 'Nietzsche' },
  { text: 'kaç dostum, yalnızlığına kaç! zehirli sineklerin sokmasından bıktın', author: 'Nietzsche, Zerdüşt' },
  { text: 'en iyi intikam, kötülük yapana benzememektir', author: 'Marcus Aurelius' },
  { text: 'dünya utanmazlar olmadan var olamaz; imkânsızı isteme', author: 'Marcus Aurelius' },
  { text: 'kalabalık, hakikatsizliktir', author: 'Kierkegaard' },
  { text: 'kitlelerde biriken zekâ değil, vasatlıktır', author: 'Gustave Le Bon' },
  { text: 'seni kötüleyen, öbür kusurlarını bilmiyor demektir', author: 'Epiktetos' },
  { text: 'asıl hüner, düşmanı savaşmadan alt etmektir', author: 'Sun Tzu' },
  { text: 'asla bir domuzla güreşme; o bundan keyif alır', author: 'G. B. Shaw' },
];

/* ════ QUOTE RAIN ════ */
function QuoteRain() {
  const [pool, setPool] = useState([]);

  // dusen soz dibe varinca birikintiy​e katilir, sel tavana dogru buyur
  const addToPool = (q) => {
    setPool(p => (p.length >= 120 ? p : [...p, q]));
  };

  return (
    <div className="rain-box" aria-hidden="true">
      {RAIN_QUOTES.map((q, i) => (
        <span
          key={i}
          className="raindrop"
          style={{
            left: `${(i * 29) % 85}%`,
            animationDelay: `${(i * 1.4) % 8}s`,
            animationDuration: `${6 + (i % 5) * 1.8}s`,
            fontSize: `${16 + ((i * 7) % 4) * 4}px`,
            '--drift': `${((i * 53) % 240) - 120}px`,
            '--tilt': `${((i * 41) % 24) - 12}deg`,
          }}
          onAnimationIteration={() => addToPool(q)}
        >
          "{q.text}" — {q.author}
        </span>
      ))}
      <div className="word-pool">
        {pool.map((q, i) => (
          <span key={i} className="pool-word" style={{ '--rot': `${(i % 7) - 3}deg` }}>
            {q.text}
          </span>
        ))}
      </div>
    </div>
  );
}

/* ════ useTheme ════ */
function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem('lm-theme') === 'dark');
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem('lm-theme', dark ? 'dark' : 'light');
  }, [dark]);
  return [dark, useCallback(() => setDark(d => !d), [])];
}

/* ════ LOADING DOTS ════ */
function LoadingDots() {
  return <span className="loading-dots"><span /><span /><span /></span>;
}

/* ════ ERROR TOAST ════ */
function ErrorToast({ message, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="error-toast" onClick={onClose}>
      <span className="error-toast-text">{message}</span>
      <span className="error-toast-close">&times;</span>
    </div>
  );
}

/* ════ ÖNEMLİ SÖZLER PAGE ════ */
function QuotesPage({ onBack }) {
  return (
    <div className="container">
      <button className="back-btn" onClick={onBack}>geri</button>
      <h1 className="quotes-title">onemli sozler</h1>
      <div className="quotes-divider" />
      {QUOTES.length === 0 && <div className="q-empty">yakinda eklenecek...</div>}
      {QUOTES.map((q, i) => (
        <div key={i} className="q-item">
          <div className="q-text">"{q.text}"</div>
          <div className="q-author">-- {q.author}</div>
        </div>
      ))}
    </div>
  );
}

/* ════ ÖNEMLİ KİTAPLAR PAGE ════ */
function BooksPage({ onBack }) {
  return (
    <div className="container">
      <button className="back-btn" onClick={onBack}>geri</button>
      <h1 className="quotes-title">onemli kitaplar</h1>
      <div className="quotes-divider" />
      {BOOKS.length === 0 && <div className="q-empty">yakinda eklenecek...</div>}
      {BOOKS.map((b, i) => (
        <div key={i} className="q-item">
          <div className="q-book-title">{b.title}</div>
          <div className="q-author">{b.author}</div>
          {b.review && <div className="q-review">{b.review}</div>}
        </div>
      ))}
    </div>
  );
}

/* ════ APP ════ */
function App() {
  const [dark, toggleTheme] = useTheme();
  const [page, setPage] = useState('main');
  const [input, setInput] = useState('');
  const [lincler, setLincler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [replyInputs, setReplyInputs] = useState({});
  const [analysis, setAnalysis] = useState(null);
  const [visibleComments, setVisibleComments] = useState(0);
  const [error, setError] = useState(null);
  const [loadingId, setLoadingId] = useState(null);

  // staggered reveal
  useEffect(() => {
    if (lincler.length > 0 && visibleComments < lincler.length) {
      const t = setTimeout(() => setVisibleComments(p => p + 1), 320);
      return () => clearTimeout(t);
    }
  }, [visibleComments, lincler.length]);

  const apiCall = async (body) => {
    const res = await fetch(`${API_URL}/api/generate-linc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      throw new Error(errData.error || `hata (${res.status})`);
    }
    return res.json();
  };

  const handleInitial = async () => {
    if (!input.trim() || loading) return;
    setLoading(true);
    setError(null);
    setVisibleComments(0);
    try {
      const data = await apiCall({ action: 'initial', statement: input });
      if (data.yorumlar) {
        setLincler(data.yorumlar.map((l) => ({
          ...l,
          troll: randomTroll(),
          conversation: [{ role: 'Elestiren', text: l.text }],
        })));
        setInput('');
        setReplyInputs({});
      }
    } catch (err) {
      setError(err.message || 'bir seyler ters gitti, tekrar dene');
    } finally {
      setLoading(false);
    }
  };

  const handleReply = async (id) => {
    const reply = (replyInputs[id] || '').trim();
    if (!reply || loading) return;
    const linc = lincler.find(l => l.id === id);
    setLoadingId(id);
    setError(null);
    try {
      const data = await apiCall({ action: 'reply', linc_text: linc.text, user_reply: reply });
      if (data.response) {
        setLincler(p => p.map(l => l.id === id ? {
          ...l,
          conversation: [...l.conversation, { role: 'Sen', text: reply }, { role: 'Elestiren', text: data.response }],
        } : l));
        setReplyInputs(p => ({ ...p, [id]: '' }));
      }
    } catch (err) {
      setError(err.message || 'cevap gonderilemedi');
    } finally {
      setLoadingId(null);
    }
  };

  const handleRemove = (id) => {
    setLincler(p => p.filter(l => l.id !== id));
    if (expandedId === id) setExpandedId(null);
    setVisibleComments(p => Math.max(0, p - 1));
  };

  const handleAnalyze = async () => {
    if (!lincler.length) return;
    setLoading(true);
    setError(null);
    try {
      const data = await apiCall({ action: 'analyze', conversation: lincler.flatMap(l => l.conversation) });
      setAnalysis(data);
    } catch (err) {
      setError(err.message || 'analiz yapilamadi');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setLincler([]);
    setAnalysis(null);
    setExpandedId(null);
    setReplyInputs({});
    setVisibleComments(0);
    setError(null);
  };

  const isReplyLoading = (id) => loadingId === id;

  return (
    <div className="app">
      {page === 'main' && lincler.length === 0 && !analysis && <QuoteRain />}
      {error && <ErrorToast message={error} onClose={() => setError(null)} />}

      <header className="site-header">
        <h1 className="brand" onClick={() => { setPage('main'); }}>
          lincmatik! <span className="brand-ribbon">🎀</span>
        </h1>
        <nav className="site-nav">
          <button className="nav-link" onClick={() => setPage(page === 'quotes' ? 'main' : 'quotes')}>
            sozler
          </button>
          <button className="nav-link" onClick={() => setPage(page === 'books' ? 'main' : 'books')}>
            kitaplar
          </button>
          <button className="nav-link" onClick={toggleTheme} aria-label="Toggle theme">
            {dark ? 'light' : 'dark'}
          </button>
        </nav>
      </header>

      {page === 'quotes' && <QuotesPage onBack={() => setPage('main')} />}
      {page === 'books' && <BooksPage onBack={() => setPage('main')} />}

      {page === 'main' && (
        <div className="container">

          {/* LANDING */}
          {lincler.length === 0 && !analysis && (
            <div className="landing">
              <p className="landing-desc">
                mental dayaniklilik antrenmani. bir sey paylas, internetteki
                en kotu yorumlari gorelim. cevap ver, analiz al, daha guclu ol.
              </p>
              <div className="input-area">
                <textarea
                  className="main-input"
                  placeholder="ne paylasiyorsun?"
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleInitial();
                    }
                  }}
                  disabled={loading}
                  maxLength={1000}
                />
                <div className="input-footer">
                  <span className="char-count">{input.length}/1000</span>
                  <button className="btn" onClick={handleInitial} disabled={loading || !input.trim()}>
                    {loading ? <LoadingDots /> : 'getir bakalim'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* LINC LIST */}
          {lincler.length > 0 && !analysis && (
            <>
              <p className="list-label">senin paylasimina gelenler ({lincler.length}):</p>
              <ul className="linc-list">
                {lincler.slice(0, visibleComments).map((linc) => {
                  const isExpanded = expandedId === linc.id;
                  const replyVal = replyInputs[linc.id] || '';
                  const replyBusy = isReplyLoading(linc.id);

                  return (
                    <li key={linc.id} className="linc-item">
                      <div className="linc-row" onClick={() => setExpandedId(isExpanded ? null : linc.id)}>
                        <span className="linc-handle">{linc.troll.handle}</span>
                        <span className="linc-text">{linc.text}</span>
                        <span className="expand-mark">{isExpanded ? '[−]' : '[+]'}</span>
                      </div>

                      {isExpanded && (
                        <div className="linc-expanded">
                          {linc.conversation.length > 1 && (
                            <div className="conversation">
                              {linc.conversation.slice(1).map((msg, idx) => (
                                <div key={idx} className={`msg ${msg.role === 'Sen' ? 'user' : 'ai'}`}>
                                  <strong>{msg.role === 'Sen' ? 'sen:' : linc.troll.handle + ':'}</strong>
                                  <span>{msg.text}</span>
                                </div>
                              ))}
                            </div>
                          )}
                          <div className="reply-area">
                            <input
                              type="text"
                              placeholder="cevabini yaz..."
                              value={replyVal}
                              onChange={e => setReplyInputs(p => ({ ...p, [linc.id]: e.target.value }))}
                              onKeyDown={e => e.key === 'Enter' && handleReply(linc.id)}
                              disabled={replyBusy}
                              maxLength={500}
                            />
                            <button className="btn" onClick={() => handleReply(linc.id)} disabled={replyBusy || !replyVal.trim()}>
                              {replyBusy ? <LoadingDots /> : 'gonder'}
                            </button>
                          </div>
                          <button className="remove-btn" onClick={() => handleRemove(linc.id)}>
                            ugrasma, sil
                          </button>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
              {visibleComments === lincler.length && (
                <div className="bottom-actions">
                  <button className="btn" onClick={handleAnalyze} disabled={loading}>
                    {loading ? <LoadingDots /> : 'tumunu analiz et'}
                  </button>
                  <button className="btn quiet" onClick={handleReset}>yeniden basla</button>
                </div>
              )}
            </>
          )}

          {/* ANALYSIS */}
          {analysis && (
            <div className="analysis-box">
              <h2>psikolojik analiz</h2>
              {analysis.kullanici_durum && (
                <div className="analysis-section">
                  <h3>senin durumun</h3>
                  <p>{analysis.kullanici_durum}</p>
                </div>
              )}
              {analysis.elestiren_durum && (
                <div className="analysis-section">
                  <h3>elestirenler</h3>
                  <p>{analysis.elestiren_durum}</p>
                </div>
              )}
              {analysis.genel && (
                <div className="analysis-section">
                  <h3>genel degerlendirme</h3>
                  <p>{analysis.genel}</p>
                </div>
              )}
              {analysis.error && (
                <div className="analysis-section">
                  <p>{analysis.error}</p>
                </div>
              )}
              <div className="bottom-actions">
                <button className="btn" onClick={handleReset}>yeni simulasyon</button>
              </div>
            </div>
          )}
        </div>
      )}

      <footer className="app-footer">
        <span className="footer-bow" aria-hidden="true">🎀</span>
        <span className="footer-quote">"asla bir domuzla guresme. ikiniz de camur icinde kalirsiniz ama o bundan keyif alir."</span>
        <span className="footer-sig">damlahelloworld</span>
      </footer>
    </div>
  );
}

export default App;
